import { AccidentAnalysisResult, AccidentAnalysisState } from '../types/state';

const FETCH_START = 'accidentAnalysis/FETCH_START';
const FETCH_SUCCESS = 'accidentAnalysis/FETCH_SUCCESS';
const FETCH_FAILURE = 'accidentAnalysis/FETCH_FAILURE';

const initialState: AccidentAnalysisState = {
  loading: false,
  error: null,
  data: null,
};

export function reducer(state = initialState, action: any): AccidentAnalysisState {
  switch (action.type) {
    case FETCH_START:
      return { ...state, loading: true, error: null };
    case FETCH_SUCCESS:
      return { ...state, loading: false, data: action.payload as AccidentAnalysisResult };
    case FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload as string };
    default:
      return state;
  }
}

export function fetchAccidentAnalysis(year?: number, month?: number) {
  return async (dispatch: (action: any) => void, _getState: () => unknown, { services }: any) => {
    dispatch({ type: FETCH_START });
    try {
      const result = await services.dataSource.getAccidentAnalysis(year, month);
      dispatch({ type: FETCH_SUCCESS, payload: result });
    } catch (error) {
      console.error('[accidentAnalysis] fetch error', error);
      dispatch({ type: FETCH_FAILURE, payload: 'Failed to fetch accident analysis' });
    }
  };
}
